(function(itxApp) {
    'use strict';


    angular.module('itxApp.common').filter('translateCms', ['itxCmsUtilsSvc',ItxTranslateFlt]);

    function ItxTranslateFlt(itxCmsUtilsSvc) {
        return function(value){
            return itxCmsUtilsSvc.t(value);
        };
    }
    /** Public **/
    itxApp.common.ItxTranslateFlt = ItxTranslateFlt;
    
})(window.itxApp);